// extracted by mini-css-extract-plugin
export default {"wrapper":"Breadcrumbs_wrapper__177Qa","separator":"Breadcrumbs_separator__ONDik","crumb-wrapper":"Breadcrumbs_crumb-wrapper__rAcnt","crumb":"Breadcrumbs_crumb__xs0wK"};